module.exports = __webpack_public_path__ + "static/CUPULA-60831ff0da48a20b2c4e175b57f9b8bd.webp";